import { useState } from "react"
import { JsonFormaterInput } from "../theme/Component/JsonFormaterInput";
import { BasicButton } from "../theme/Component/BasicButton";
import { AdminService } from "../../core/services/AdminService";
import { _single } from "../../core/services/dataBean/EntityCatalog";

export const TestApi = () => {

    const service = new AdminService();
    const [json, setJson] = useState<any>();
    const [response, setResponse] = useState<any>({});

    const sendService = () => {
        _single.spinner(true);
        service.testService(json).subscribe(
            (resp: any) => {
                console.log(resp);
                
                if (resp.DataBeanProperties.ErrorMessage) {
                    setResponse(resp.DataBeanProperties);
                }
                else if (resp.DataBeanProperties.ObjectValue) {                    
                    setResponse(resp.DataBeanProperties.ObjectValue);
                }else{
                    setResponse(resp.DataBeanProperties);
                }
                _single.spinner(false);
            }
        )
    }
    const cleanText = () => {
        // setJson({});
        setResponse({});
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicButton icon="" eventClick={sendService}>Enviar</BasicButton>
                <BasicButton icon="" eventClick={cleanText}>Limpiar</BasicButton>
            </div>
            <div className="col-md">
                <JsonFormaterInput rows={20} inputType="string" onChange={setJson} returnType="object" _label="Servicio" />
            </div>
            <div className="col-md">
                <JsonFormaterInput rows={20} inputType="object" value={response} onChange={setResponse} returnType="object" _label="Respuesta" />
            </div>
        </div>
    )

}